import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Well, WellItem, WellLabel, WellBigNumber } from 'foundations-components/transitional/components/Well';
import { getJourneySummaryMetrics } from 'reporting-ui-components/lib/getJourneySummaryMetrics';
import { useGate } from '../../../../../../../hooks/useGate';
import { SRV_REDESIGN_2025_Q2_GATE } from '../../../../../../../constants/gates';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const JourneyReportKPIContent = ({
  reportResolve
}) => {
  const isSRVSidebarRedesign2025Q2Enabled = useGate(SRV_REDESIGN_2025_Q2_GATE);
  if (!reportResolve) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      layout: "centered"
    });
  }
  const metrics = getJourneySummaryMetrics(reportResolve.toJS());
  return /*#__PURE__*/_jsx(Well, {
    padding: "0",
    margin: "0",
    paddingBlockStart: isSRVSidebarRedesign2025Q2Enabled ? '400' : '0',
    children: metrics.map(metric => /*#__PURE__*/_jsxs(WellItem, {
      padding: "0",
      margin: "0",
      children: [/*#__PURE__*/_jsx(WellLabel, {
        children: /*#__PURE__*/_jsx(HelpIcon, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `reporting-ui-components.journeyMetricTooltips.${metric.key}`
          }),
          children: metric.label
        })
      }), /*#__PURE__*/_jsx(WellBigNumber, {
        children: metric.value
      })]
    }, metric.key))
  });
};
export default JourneyReportKPIContent;